<template>
  <div class="wlx-exam-center-table-wrapper">
    <div class="pc-com-signUp-con">
      <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
        <div class="basic-head-con">
          <div class="head-title-con clearfix">
            <div class="fl basic-book-img-con">
              <img src="~assets/images/basic-book-img.png" alt />
            </div>
            <div class="fr head-title-word">
              <p class="p-title-1">物流行指委下设专业</p>
              <p class="p-title-1">委员会委员申请表</p>
              <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
            </div>
          </div>
        </div>
      </div>
      <div class="apply-table-content" id="export_word">
        <table border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td class="u-label-title" colspan="2">姓名</td>
            <td colspan="2">
              <el-input v-model="name"></el-input>
            </td>
            <td class="u-label-title" colspan="1">性别</td>
            <td colspan="1">
              <el-select v-model="sex" placeholder>
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </td>
            <td class="u-label-title" colspan="2">出生年月</td>
            <td colspan="3">
              <!-- <el-input v-model="dateCreated"></el-input> -->
              <el-date-picker v-model="dateCreated" type="date" placeholder="选择日期"></el-date-picker>
            </td>
            <td class="u-label-title" colspan="1">民族</td>
            <td colspan="2">
              <el-input v-model="ancestor"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">单位</td>
            <td colspan="4">
              <el-input v-model="company"></el-input>
            </td>
            <td class="u-label-title" colspan="2">职务/职称</td>
            <td colspan="6">
              <el-input v-model="job"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">毕业学校</td>
            <td colspan="4">
              <el-input v-model="school"></el-input>
            </td>
            <td class="u-label-title" colspan="2">学历/学位</td>
            <td colspan="6">
              <el-input v-model="education"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">社会兼职</td>
            <td colspan="4">
              <el-input v-model="socialJob"></el-input>
            </td>
            <td class="u-label-title" colspan="2">目前从事的专业</td>
            <td colspan="6">
              <el-input v-model="major"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">通信地址</td>
            <td colspan="4">
              <el-input v-model="address"></el-input>
            </td>
            <td class="u-label-title" colspan="2">邮政编码</td>
            <td colspan="6">
              <el-input v-model="number"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">手机</td>
            <td colspan="4">
              <el-input v-model="phone"></el-input>
            </td>
            <td class="u-label-title" colspan="2">电子邮箱</td>
            <td colspan="6">
              <el-input v-model="email"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2">是否为原专委会委员</td>
            <td colspan="4">
              <el-select v-model="isCommittee" placeholder>
                <el-option label="是" value="0"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </td>
            <td class="u-label-title" colspan="2">意向加入专业委员会委员</td>
            <td colspan="6">
              <el-select v-model="committeeType" placeholder>
                <el-option
                  v-for="(item,index) in committee"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2" valign="middle">工作简历</td>
            <td colspan="12">
              <el-input type="textarea" :rows="10" v-model="resume"></el-input>
            </td>
          </tr>
          <tr>
            <td class="u-label-title" colspan="2" valign="middle">专委会工作建议</td>
            <td colspan="12">
              <el-input type="textarea" :rows="10" v-model="advise"></el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="apply-table-contents">
        <div class="submit-apply-btn">
          <el-button type="primary" @click="submitApply(false)">提交申请</el-button>
        </div>
      </div>
    </div>
    <!-- 手机端报名 -->
    <div class="ph-com-signUp-con">
      <div class="sign-head-con clearfix" :style="{backgroundImage:'url('+headBg+')'}">
        <img src="~assets/images/basic-book-img.png" alt class="ph-head-img" />
        <div class="fr sign-title-con">
          <p class="p-title-1">物流行指委下设专业</p>
          <p class="p-title-1">委员会委员申请表</p>
          <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
        </div>
      </div>
      <div class="sign-up-table-main">
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>姓名</span>
        </p>
        <div>
          <el-input v-model="name" autofocus size="small" placeholder="请输入姓名"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>性别</span>
        </p>
        <div>
          <el-select v-model="sex" placeholder="请选择性别" size="small">
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </div>

        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>手机</span>
        </p>
        <div>
          <el-input v-model="phone" placeholder="请输入手机号" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>邮箱</span>
        </p>
        <div>
          <el-input v-model="email" placeholder="请输入邮箱" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>出生年月</span>
        </p>
        <div>
          <el-date-picker size="small" v-model="dateCreated" type="date" placeholder="请选择日期"></el-date-picker>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>民族</span>
        </p>
        <div>
          <el-input v-model="ancestor" placeholder="请输入民族" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>单位</span>
        </p>
        <div>
          <el-input v-model="company" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>职务/职称</span>
        </p>
        <div>
          <el-input v-model="job" placeholder="请输入职务/职称" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>毕业学校</span>
        </p>
        <div>
          <el-input v-model="school" placeholder="请输入毕业院校" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>学历/学位</span>
        </p>
        <div>
          <el-input v-model="education" placeholder="请输入学历/学位" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>社会兼职</span>
        </p>
        <div>
          <el-input v-model="socialJob" placeholder="请输入社会兼职" size="small"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>目前从事的专业</span>
        </p>
        <div>
          <el-input v-model="major" size="small" placeholder="目前从事的专业"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>通信地址</span>
        </p>
        <div>
          <el-input v-model="address" size="small" placeholder="通信地址"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>邮政编码</span>
        </p>
        <div>
          <el-input v-model="number" size="small" placeholder="邮政编码"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>是否为原专委会委员</span>
        </p>
        <div>
          <el-select v-model="isCommittee" placeholder="请选择" size="small">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>意向加入专业委员会委员</span>
        </p>
        <div>
          <el-select v-model="committeeType" placeholder="请选择" size="small">
            <el-option
              v-for="(item,index) in committee"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
         <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>工作简历</span>
        </p>
        <div>
            <el-input type="textarea"  placeholder="请输入工作简历" :rows="6" v-model="resume"></el-input>
        </div>
         <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>专委会工作建议</span>
        </p>
        <div>
            <el-input type="textarea"  placeholder="请输入专委会工作建议" :rows="6" v-model="advise"></el-input>
        </div>
        <div class="ph-submit-con">
          <el-button size="small" type="primary" @click="backToHome">返回</el-button>
          <el-button size="small" type="primary" @click="submitApply(true)">提交</el-button>
        </div>
      </div>
    </div>
    <!-- 是否填写提示弹框 -->
    <el-dialog title="提示" :visible.sync="IsTipsDialog" :close-on-click-modal="false" width="600px">
      <div class="wlx-is-fill-signUp-con">
        <p>
          <span>
            您是否已参与委员申请？如已参与，您可以
            <router-link :to="target" v-if="userInfo.code > 0">直接进入</router-link>
            <a style="color:blue;cursor:pointer;" @click="Gologin()" v-if="userInfo.code < 0">直接进入</a>
            后台编辑相关信息
          </span>
        </p>
        <!-- <p class="p-name-pass-tip-con">* 用户名为申请人手机号,初始密码为手机号的后6位</p> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsTipsDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="IsPhoneDialog" :close-on-click-modal="false" width="80%">
      <div class="wlx-is-fill-diaocha-con">
        <p>如已经填报过，请使用电脑端操作</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsPhoneDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <newLogin :isShow="showObject" class="wlx-dialog-class"></newLogin>
  </div>
</template>

<script>
import newLogin from "components/newLogin.vue";
import { MU_UPATE_AUTH } from "store/index";
export default {
  components: {
    newLogin
  },
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      name: "",
      sex: "",
      dateCreated: "",
      ancestor: "",
      company: "",
      job: "",
      school: "",
      education: "",
      socialJob: "",
      major: "",
      address: "",
      number: "",
      phone: "",
      email: "",
      resume: "",
      advise:"",
      committee: [
        {
          label: "教学改革专业委员会",
          value: "1"
        },
        {
          label: "技能开发专业委员会",
          value: "2"
        },
        {
          label: "校企合作专业委员会",
          value: "3"
        },
        {
          label: "国际合作专业委员会",
          value: "4"
        },
        {
          label: "信息化专业委员会",
          value: "5"
        },
        {
          label: "师资建设专业委员会",
          value: "6"
        }
      ],
      committeeType: "",
      isCommittee: "",
      IsTipsDialog: false,
      showObject: {
        isShow: false
      },
      timer: null,
      IsPhoneDialog: false,
      screenWidth: document.body.clientWidth
    };
  },
  created() {
    if (this.screenWidth < 800) {
      this.IsTipsDialog = false;
      this.IsPhoneDialog = true;
    } else {
      this.IsTipsDialog = true;
      this.IsPhoneDialog = false;
    }
    this.getToken();
  },
  props:{
    userId:{
      type:String,
      default:""
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    target: function() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaPilotManager";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "committeeManager";
      }
      return { name: Urlname };
    }
  },
  methods: {
    getToken(){
      var that = this;
      this.$http.post("/api/XOrg/XLogin/getToken",{
        secretKey:"r3yyab2q6q9p2f7ixhdoq",
        successURL:"http://localhost:8087"
      }).then(rst=>{
        if (rst.status > 0) {
          this.$http.post("/api/XOrg/XLogin/oauthLogin",{
            loginType:2,
            userId:this.userId,
            token:rst.token,
            successURL:"http://localhost:8087"
          }).then(
            this.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              that.name = that.userInfo.displayName;
              that.company = that.userInfo.userSchoolName;
            })
          );
        }
      });
    },
    backToHome() {
      this.$router.push({
        name: "xIndex"
      });
    },
    Gologin() {
      this.IsTipsDialog = false;
      this.showObject = {
        isShow: true
      };
    },
    
    submitApply(isTrue) {
      const reg = /^1\d{10}$/;
      if (this.name == "") {
        this.$message.warning("请输入姓名");
        return false;
      }
      if (this.sex == "") {
        this.$message.warning("请选择性别");
        return false;
      }
      if (this.dateCreated == "") {
        this.$message.warning("请输入出生年月");
        return false;
      }
      if (this.ancestor == "") {
        this.$message.warning("请输入民族");
        return false;
      }
      if (this.company == "") {
        this.$message.warning("请输入单位");
        return false;
      }
      if (this.job == "") {
        this.$message.warning("请输入职称/职务");
        return false;
      }
      if (this.school == "") {
        this.$message.warning("请输入毕业学校");
        return false;
      }
      if (this.education == "") {
        this.$message.warning("请输入学历/学位");
        return false;
      }
      if (this.socialJob == "") {
        this.$message.warning("请输入社会兼职");
        return false;
      }
      if (this.major == "") {
        this.$message.warning("请输入目前从事的专业");
        return false;
      }
      if (this.address == "") {
        this.$message.warning("请输入通信地址");
        return false;
      }
      if (this.number == "") {
        this.$message.warning("请输入邮政编码");
        return false;
      }
      if (this.phone == "") {
        this.$message.warning("请输入手机号");
        return false;
      } else if (!reg.test(this.phone)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (this.email == "") {
        this.$message.warning("请输入电子邮箱");
        return false;
      }
      if (this.isCommittee == "") {
        this.$message.warning("请选择是否为原专委会委员");
        return false;
      }
      if (this.committeeType == "") {
        this.$message.warning("请选择专业委员会委员类型");
        return false;
      }
      // if (this.resume == "") {
      //   this.$message.warning("请输入简介");
      //   return false;
      // }
      this.$http
        .post("/api/XOrg/Committee/addCommitteeInfo", {
          name: this.name,
          sex: this.sex,
          dateCreated: this.dateCreated,
          ancestor: this.ancestor,
          company: this.company,
          job: this.job,
          school: this.school,
          education: this.education,
          socialJob: this.socialJob,
          major: this.major,
          address: this.address,
          number: this.number,
          phone: this.phone,
          email: this.email,
          resume: this.resume,
          isCommittee: this.isCommittee,
          committeeType: this.committeeType,
          advise:this.advise
        })
        .then(res => {
          if (res.code > 0) {
            if (isTrue == false) {
              this.$message.success(
                "申请成功,即将跳转到管理系统!"
              );
              this.timer = setInterval(this.goclpp, 3000);
            } else {
              this.$message.success(
                "申请成功,即将返回，可使用电脑进行操作!"
              );
              this.timer = setInterval(this.backToHome, 3000);
            }
          } else {
            this.$message.warning(res.msg);
            return;
          }
        });
    },
    goclpp() {
      this.$router.push({
        name: "committeeManager"
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss">
.apply-table-contents {
  width: 1000px;
  margin: 0 auto;
}
.sp-city-con {
  background: #fff;
  display: inline-block;
  width: 220px;
  line-height: 40px;
  padding: 0 10px;
}
.wlx-exam-center-table-wrapper {
  .el-select {
    width: 100%;
  }
  .el-upload-list {
    background: #fff;
  }
  .wlx-is-fill-signUp-con {
    font-size: 16px;
    .p-name-pass-tip-con {
      margin-top: 10px;
      color: red;
    }
  }
  .wlx-dialog-class {
    .el-input__inner {
      border: 1px solid #dcdfe6;
    }
  }
  .ph-com-signUp-con {
    display: none;
    .sign-head-con {
      height: 160px;
    }
    .ph-head-img {
      margin: 20px 0 0 20px;
      width: 30%;
    }
    .sign-title-con {
      margin: 18px 20px 0 0;
      color: #fff;
      font-size: 18px;
      .p-title-2 {
        font-size: 14px;
      }
    }
    .sign-up-table-main {
      position: relative;
      padding: 20px;
      min-height: 500px;
      margin-top: -64px;
      background: #f4f7fa;
    }
    .sign-up-title-h2 {
      padding: 10px 0;
      text-align: center;
      font-size: 16px;
    }
    .p-form-child-label {
      margin: 8px 0;
    }
    .el-input__inner {
      font-size: 12px;
    }
    .ph-invoice-title {
      padding-top: 10px;
      text-align: center;
      font-size: 14px;
    }
    .ph-sign-table-1 {
      margin-top: 15px;
      border-top: 1px solid #999;
    }
    .el-table th {
      font-size: 14px;
    }
    .ph-sign-up-tip p {
      margin-bottom: 10px;
    }
    .sp-must-tip {
      color: red;
    }
    .ph-submit-con {
      margin-top: 20px;
      text-align: center;
    }
  }
}
@media only screen and (max-width: 960px) {
  .wlx-exam-center-table-wrapper {
    .pc-com-signUp-con {
      display: none;
    }
    .ph-com-signUp-con {
      display: block;
    }
  }
}
</style>
